import styled from 'styled-components';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';

export const LaunchAppBar = styled(AppBar)`
  background: linear-gradient(90deg, #0d4efe 0%, #01ebb2 100%);
  border-radius: 12px;
  padding: 0 10px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(13, 78, 254, 0.25);
`;

export const LaunchToolbar = styled(Toolbar)`
  min-height: 64px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const BrandSection = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 16px;
  min-width: 0;
`;

export const LogoButton = styled(IconButton)`
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 1);
  }
`;

export const LogoImage = styled.img`
  height: 40px;
  width: auto;
  display: block;
  object-fit: contain;
`;

export const CenterLinks = styled(Box)`
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  margin-left: 10px;
  color: #ffffff;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const LaunchLinkButton = styled(Button)`
  text-transform: none;
  font-family: 'Exo 2', sans-serif;
  font-weight: 650;
  font-size: 20px;
  color: #ffffff;
  position: relative;
  padding-bottom: 6px;

  &::after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 50%;
    width: 0;
    height: 2px;
    background: #fff;
    border-radius: 1px;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover {
    background: rgba(255, 255, 255, 0.08);

    &::after {
      width: 60%;
    }
  }
`;

export const RightActions = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 16px;
`;

export const LoginButton = styled(Button)`
  background: rgba(255, 255, 255, 0.95);
  color: #0d4efe;
  font-family: 'Exo 2', sans-serif;
  font-weight: 650;
  font-size: 16px;
  text-transform: none;
  padding: 8px 20px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  transition: all 0.25s ease;

  &:hover {
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    transform: translateY(-1px);
  }
`;

export const MobileInline = styled(Box)`
  display: none;
  align-items: center;
  gap: 10px;
  flex: 1;

  @media (max-width: 900px) {
    display: flex;
  }
`;

export const MobileDivider = styled(Divider)`
  margin: 0 2px;
  opacity: 0.45;
  border-color: rgba(255, 255, 255, 0.7);
`;

export const LaunchContainer = styled(Container)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

